<div class="bmc-uipath-detail-wrapper" *ngIf="!(isLoading$ | async) &&  uiPathConnection$ | async as uiPathConnection">
    <uipath-configuration [uiPathOriginalConnection]="uiPathOriginalConnection" [botDetail]="uiPathConnection" (save)="onSave($event)" (testConnection)="onTestConnection($event)" #botConfiguration>
    </uipath-configuration>
    <hr class="bmc-bot-detail-wrapper__horizontal-rule">
</div>

<div class="bmc-uipath-detail-wrapper__loading-container" *ngIf="(isLoading$ | async)">
    <bzg-loading [size]="'s'" class="bmc-uipath-detail-wrapper__loading">
        {{'GLOBAL.LOADING_DATA' | translate}}
    </bzg-loading>
</div>

<bots-empty *ngIf="!(uiPathConnection$ | async) && !(isLoading$ | async)">
    {{'RPA_BOTS.EMPTY_DETAIL' | translate}}
</bots-empty>
